<template>
  <div class="d-flex justify-center mt-6">
    <v-btn v-tooltip="'.'" small @click="openPreviousEvent()"><v-icon>mdi-chevron-left</v-icon><span style="color: grey;">[.]</span></v-btn>
    <v-btn :disabled="disabled" class="mx-2" small color="primary" @click="$emit('save')">Tallenna (Enter)</v-btn>
    <v-btn v-tooltip="'-'" small @click="openNextEvent()"><v-icon>mdi-chevron-right</v-icon><span style="color: grey;">[-]</span></v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex/dist/vuex.common.js';

export default {
  props: ['disabled', 'disableEnterShortcut'],
  shortcuts: {
    dash: function() { this.openNextEvent() },
    dot: function() { this.openPreviousEvent() },
    enter: function() {
      if(this.disableEnterShortcut) return
      this.$emit('save')
    },
    a: function() {
      if(!this.current_event || !this.current_event.starttime) return
      this.seek(this.current_event.starttime - 2)
    },
  },
  methods: {
    ...mapActions('analysis', [
      'openNextEvent',
      'openPreviousEvent',
    ]),
    ...mapActions('player', [
      'seek'
    ])
  },
  computed: {
    ...mapGetters('analysis', [
      'current_event'
    ])
  }
}
</script>